<ws-modal-wrapper headerLabel="Review Payment Package"
                  [hideSave]="true"
                  [hideCancel]="true"
                  acceptLabel=""
                  [loading]="loading"
                  (cancel)="close()">
    @if (!loading) {
        <div
            [style.display]="editingEmail ? 'block' : 'none'"
            class="mb-3 quill-height-fix"
            style="height: 56vh; text-align: left;">
            <!-- TODO: This is copied from custom-email-template-modal.component; we should create a shared component instead
            of copy/pasting the implementation -->
            <input type="text" id="template-subject"
                   style="width: 662px; display: inline-block; margin-left: 10px; margin-bottom: 15px;"
                   class="form-control" [(ngModel)]="emailSubjectTemplate" placeholder="Subject ...">
            <div class="btn-group buttongroup-last" style="margin-left: -5px;" dropdown>
                <button dropdownToggle type="button"
                        class="ace-btn btn-secondary dropdown-toggle"
                        style="width: initial;">
                    Insert Field
                    <span class="caret"></span>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                    @for (field of emailTemplateFields.subject; track field) {
                        <li role="menuitem">
                            <a style="cursor: pointer;" class="dropdown-item"
                               (click)="insertFieldInSubject(field)">{{ field.name }}</a>
                        </li>
                    }
                </ul>
            </div>
            <quill-editor [(ngModel)]="emailTextTemplate"
                          (onContentChanged)="contentChange($event)"
                          [placeholder]="'Email Body ...'"
                          (onEditorCreated)="addBindingCreated($event)"
                          class="w-100">
                <div quill-editor-toolbar>
                    <!-- Basic buttons -->
                    <span class="ql-formats">
              <button class="ql-bold" [title]="'Bold'"></button>
              <button class="ql-italic" [title]="'Italic'"></button>
              <button class="ql-underline" [title]="'Underline'"></button>
              <button class="ql-strike" [title]="'Strike'"></button>
            </span>
                    <!-- Size -->
                    <span class="ql-formats">
              <select class="ql-size" [title]="'Size'">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
            </span>
                    <span class="ql-formats">
              <select class="ql-align" [title]="'Aligment'">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
                    <div class="btn-group" dropdown>
                        <button dropdownToggle type="button" class="btn dropdown-toggle" style="width: initial;">
                            Insert Field
                            <span class="caret"></span>
                        </button>
                        <ul *dropdownMenu class="dropdown-menu" role="menu">
                            @for (field of emailTemplateFields?.body; track field) {
                                <li role="menuitem">
                                    <a style="cursor: pointer;" class="dropdown-item"
                                       (click)="insertFieldInBody(field)">{{ field.name }}</a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </quill-editor>
        </div>
    }
    @if (!loading) {
        <div
            [class.d-none]="editingEmail"
            class="d-flex flex-column">
            @if (availableAttachments?.length > 0) {
                <div class="d-flex justify-content-end" style="margin-top:-20px;">
                    <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedAttachment"
                            (ngModelChange)="onAttachmentChange($event)">
                        @for (feedAttachment of availableAttachments; track feedAttachment) {
                            <option [ngValue]="feedAttachment">
                                {{ feedAttachment.fileName }}.{{ feedAttachment.fileExtension }}
                            </option>
                        }
                    </select>
                </div>
            }
            <div style="text-align: left;">
                <!--<h3>Email Contents</h3>-->
                <div>
                    To:
                    @for (
                        recipient of package.paymentPackageRecipients | recipientType: { recipientType: RecipientType.ResponsibleParty }; track recipient; let
                        last = $last; let first = $first) {
                        <span
                        >
                {{ recipient.fullName }}@if (!last) {
                            <span>; </span>
                        }
            </span>
                    }
                </div>
                <div>
                    @for (
                        recipient of package.paymentPackageRecipients | recipientType: { recipientType: RecipientType.Cc }; track recipient; let
                        last = $last; let first = $first) {
                        <span
                        >
              @if (first) {
                  <span>Cc:</span>
              }
                            {{ recipient.fullName }}@if (!last) {
                            <span>; </span>
                        }
          </span>
                    }
                </div>
                <div>
                    @for (
                        recipient of package.paymentPackageRecipients | recipientType: { recipientType: RecipientType.Bcc }; track recipient; let
                        last = $last; let first = $first) {
                        <span
                        >
            @if (first) {
                <span>Bcc:</span>
            }
                            {{ recipient.fullName }}@if (!last) {
                            <span>; </span>
                        }
        </span>
                    }
                </div>
                @if (emailText) {
                    <div class="data-text-field"
                         style="text-align: left; margin-bottom: 10px; margin-top: 4px; overflow: auto;"
                         [ngClass]="{'editable-email-subject':previewMode}">
                        <span>{{ emailSubject }}</span>
                    </div>
                }
                @if (previewMode) {
                    <div style="float: right; margin: 16px;">
                        @if (!loading) {
                            <i
                                class="fa fa-pencil"
                                style="position: absolute; cursor: pointer;"
                                (click)="beginEditEmail()">
                            </i>
                        }
                    </div>
                }
                @if (emailText) {
                    <div class="data-text-field email-preview-display"
                         style="text-align: left; margin-bottom: 10px; margin-top: 4px; height: 100px; overflow: auto;"
                         [innerHTML]="emailText">
                    </div>
                }
            </div>
            @if (!attachmentSizeWarn && selectedAttachment.fileExtension === 'pdf') {
                <div style="height: 300px;">
                    <pdf-viewer [fileUrl]="attachmentUrl"></pdf-viewer>
                </div>
            }
            @if (attachmentSizeWarn) {
                <div>
                    <h3>
                        This file is large and may take a long time to preview.
                        Please use the download button below or
                        <a style="cursor: pointer" (click)="previewAnyway()">Click here</a> to preview the file anyway.
                    </h3>
                </div>
            }
            @if (selectedAttachment.fileExtension !== 'pdf') {
                <div>
                    <h3>Preview not supported. Please use the download button below.</h3>
                </div>
            }
        </div>
    }
    <div class="line modal-footer">
        @if (editingEmail) {
            <div>
                <button class="ace-btn btn-primary"
                        [disabled]="this.loading"
                        (click)="saveEditEmail()">
                    Save
                </button>
                <button class="ace-btn btn-secondary"
                        [disabled]="this.loading"
                        (click)="cancelEditEmail()">
                    Cancel
                </button>
            </div>
        }
        @if (!editingEmail) {
            <div class="d-flex">
                @if (this.downloading) {
                    <span style="font-size:25px;margin-right:5px;">
                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                    </span>
                }
                @if (selectedAttachment) {
                    <button class="ace-btn has-icon btn-lg btn-primary m-0"
                            (click)="downloadAttachment()"
                            tooltip="Download Package File"
                            [disabled]="this.loading || this.downloading">
                        <i class="fa fa-download"></i>
                    </button>
                }
                <button class="ace-btn btn-primary"
                        style="height: 40px;"
                        (click)="close()">
                    Close
                </button>
            </div>
        }
    </div>
</ws-modal-wrapper>
